import type { AxiosError } from 'axios';
import type { FC } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { ShieldLock } from 'react-bootstrap-icons';
import type { ErrorEnvelop } from '../../modules/hooks';
import { getApiErrorMessage } from '../../modules/utils/transform';
import {
  GuestPortalErrors,
  guestPortalErrorsMapper,
} from '../Modals/GuestPagesModalsV2/constants/GuestPortalConstants';

interface GuestPortalErrorPops {
  error?: AxiosError<ErrorEnvelop>;
  unregisteredReservation?: boolean;
}

export const GuestPortalErrorPage: FC<GuestPortalErrorPops> = ({
  error,
  unregisteredReservation,
}) => {
  const errorMessage = error ? getApiErrorMessage(error) : '';

  const guestPortalError: keyof typeof guestPortalErrorsMapper = unregisteredReservation
    ? 'INVALID_STATE'
    : errorMessage.includes(GuestPortalErrors.INVALID_RESERVATION_ID)
      ? 'INVALID_RESERVATION_ID'
      : errorMessage === GuestPortalErrors.INVALID_STATE
        ? 'INVALID_STATE'
        : errorMessage === GuestPortalErrors.NOT_FOUND
          ? 'NOT_FOUND'
          : 'GENERIC';

  return (
    <Container
      fluid
      className="login d-flex flex-column justify-content-center"
      id="guest-portal"
    >
      <Container className="content" fluid>
        <Row className="justify-content-md-center loginHeader">
          <ShieldLock color="white" size={70} />
          <Col className="justify-content-md-center mt-16px" xs="auto" sm="auto">
            <h3 className="login-heading">
              {guestPortalErrorsMapper[guestPortalError].title}
            </h3>
            <h5 className="error-subtitle">
              {guestPortalErrorsMapper[guestPortalError].subtitle}
            </h5>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
